<template>
<Modal title="添加海报" v-model="visible">
    <Form class="form" :rules="shareRules" ref="addPosterForm" :model="addPosterparams">
        <Row>
            <FormItem :label-width="90" label="海报名称：" prop='name'>
                <Input v-model="addPosterparams.name" placeholder="请输入活动名称用于列表展示"></Input>
            </FormItem>
            <FormItem :label-width="90" label="海报分类：" prop='sharePosterType'>
                <Select v-model="addPosterparams.sharePosterType">
                    <Option v-for="item in $constant.sharePosterType" :value="item.code" :key="item.code">{{item.text}}</Option>
                </Select>
            </FormItem>
            <FormItem :label-width="90" label="活动归属：" prop='activityId'>
                <activity-select v-model="addPosterparams.activityId" :label="name"></activity-select>
            </FormItem>
            <FormItem :label-width="90" label="配套海报：" prop='url'>
                <image-upload-New :defaultFileList="defaultPicList" v-model="addPosterparams.url"/>
            </FormItem>
            <FormItem :label-width="90" label="海报排序：" prop="sort">
                <InputNumber v-model="addPosterparams.sort" :min="0" :max="100000"></InputNumber>
            </FormItem>
            <FormItem :label-width="90" label="海报状态：" prop='status'>
                <Select v-model="addPosterparams.status">
                    <Option value="0" key="1">禁用</Option>
                    <Option value="1" key="2">启用</Option>
                </Select>
            </FormItem>
        </Row>
    </Form>
    <div slot="footer">
        <Button type="text" size="large" @click="visible = false">取消</Button>
        <Button type="primary" size="large" :loading="loadingAddPoster" @click="createPoster">确定</Button>
    </div>
</Modal>
</template>
<script>
export default {
  name: 'CreateChannelModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let $constant = this.$constant
    return {
      visible: this.value,
      loadingAddPoster: false,
      defaultPicList: [],
        addPosterparams: {
            name: '',
            sharePosterType: '',
            activityId: '',
            activityName: '',
            status: '',
            url: '',
            sort: null,
            createTime: '',
            updateTime: ''
        },
        shareRules: {
            name: [
              { type: 'string', required: true, message: '请输入海报名称', trigger: 'blur' },
              { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur'}
            ],
            sharePosterType: [
                { required: true, message: '选择海报分类', trigger: 'blur' }
            ],
            activityId: [
                { type:'integer', required: true, message: '请选择活动归属', trigger: 'blur' }
            ],
            url: [
                { type: 'string', required: true, message: '请上传图片', trigger: 'blur'}
            ],
            sort: [
                { type: 'number', required: true, message: '请输入图片排序', trigger: 'blur'}
            ],
            status: [
                { type: 'string', required: true, message: '请选择渠道状态', trigger: 'blur' }
            ]
        },
    }
  },
  methods: {
    createPoster () {
      let self = this
      self.loadingAddPoster = true
      self.$refs.addPosterForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingAddPoster = false
          return
        }
        self.$http.post('/share/poster/save', self.addPosterparams).then(function (res) {
            if (res && res.data > 0) {
            self.visible = false
            self.$Message.success('创建成功!')
            self.successCallback()
            self.defaultPicList = []
            }
            self.loadingAddPoster = false
        }).catch(function (e) {
            self.showAddActivityModal = false
            self.loadingAddPoster = false
        })
      })
    }
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      if (val === true) {
        this.addPosterparams = {
            name: '',
            sharePosterType: '',
            activityId: '',
            activityName: '',
            status: '',
            url: '',
            sort: null,
            createTime: '',
            updateTime: ''
        }
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateShareModal.vue?19c0ab23